import { PayloadAction } from '@reduxjs/toolkit';
import { SyfoAppState } from '../state';
import { ItemNode } from '@syfo/types/vault.types';
import { updateById } from './reducer-utils';

export const addItem = (state: SyfoAppState, action: PayloadAction<ItemNode>) => {
  if (state.currentVault) {
    state.currentVault.data.items.push(action.payload);
  }
};

export const updateItem = (state: SyfoAppState, action: PayloadAction<{ id: string; item: Partial<ItemNode> }>) => {
  if (state.currentVault) {
    updateById(state.currentVault.data.items, action.payload.id, action.payload.item);
  }
};

export const removeItem = (state: SyfoAppState, action: PayloadAction<string>) => {
  if (state.currentVault) {
    state.currentVault.data.items = state.currentVault.data.items.filter(i => i.id !== action.payload);
  }
};
